import { HttpClient } from '../../httpClient'
import { OpalApi } from '../../schema'

type CreateAssignmentV2 = OpalApi<'CreateAssignmentV2', 201>

export const createAssignment: CreateAssignmentV2 = async (args = {}) => {
  const url = new URL('/workflows/v2/assignments', window.location.origin)

  return HttpClient()
    .post(url.toString(), args.requestBody)
    .then((res) => res.data)
}
